import React, { useState } from 'react';
import { Row, Col, Form, FormGroup, Input, InputGroup, Button, Label } from 'reactstrap';

import Body from '../Components/layout/Body';
import CalloutNotice from './CalloutNotice';

const RESET_HELP = `
<div>
  <p>Here is where you can reset the password for your practitioner account.</p>
  <p>You'll end up here after clicking on the reset link that you received in your email. <strong>Note: </strong>Before clicking on the reset link, make sure Access Nav is not running in any browser tabs. It can only run properly in one browser tab, and will give an error if you try to run it in a second tab.</p>
  <p>Enter a New Password that you want to use from now on, and hit Continue.</p>
  <p>That's it.</p>
</div>
`;

//content sub-component with unique content for this page
function UsersResetPasswordContent(props) {
  const {
    resetToken,
    newPassword,
    onChangeNewPassword,
  } = props;
  

  const [isPwdHidden, setIsPwdHidden] = useState(true);

  const togglePwd = () => {
    setIsPwdHidden(!isPwdHidden);
  }

  return(
    <>
    { !resetToken ?
    <Row>
      <Col>
        <CalloutNotice 
          heading={"We're missing the required reset token"} 
          message={"That means we can't reset the password. \nGo to the Login page and try Forgot Password again."}
        />
      </Col>
      <Col lg="4"></Col>
    </Row>
    : <></>
    }

    <Row className="aa-review-row">
      <Col>
        <Form>
          {/* <FormGroup>
            <Label for="token" className="aa-bold-text">
              Token from email <span className="aa-more-info">(dev purposes only)</span>
            </Label>
            <Input
              id="token"
              value={resetToken}
              name="token"
              type="textfield"
              readOnly={true}
            />
          </FormGroup> */}
          <FormGroup>
            <Label for="newPassword" className='aa-bold-text'>
              New Password <span className="aa-field-required">*</span>
            </Label>
            <InputGroup>
              <Input
                id="newPassword"
                value={newPassword}
                onChange={onChangeNewPassword}
                name="newPassword"
                type={isPwdHidden ? "password" : "text"}
                required
              />
              <Button outline className="aa-btn-within-field" onClick={togglePwd}>
                <span className={isPwdHidden ? 'fa fa-eye' : 'fa fa-eye-slash'}></span>
              </Button>
            </InputGroup>
          </FormGroup>
        </Form>      
      </Col>
      {/* puts a little margin on the right, for large screen sizes */}
      {/* <div className="col-lg-4"></div> */}
      <Col lg="4"></Col>
    </Row>
    </>
  );
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function UsersResetPassword(props) {
  const {
    resetToken,
    newPassword,
    onChangeNewPassword,
    onContinue
  } = props;

  const pageData = {
    image: "./assets/images/target-icon.jpg", //not yet used, but could supply an image on page
    faIcon: "fa-users aa-fa-3x", //include this font-awesome icon in the image column of the page
    title: "Enter a new password",
    subTitle: "",
    learnMore: {linkText: "Learn More about resetting your password",
                title: "Password reset",
                content: RESET_HELP
                },
    nextRoute: '', 
    sidebar: false
  }

  console.log("rendering UsersUpdateCredentials");

  return(
    <>
    <Body page={pageData} 
      contentComponent={
        <UsersResetPasswordContent 
          resetToken={resetToken}
          newPassword={newPassword}
          onChangeNewPassword={onChangeNewPassword}
        />
      } 
      onContinue={onContinue}
    />
    </>
  );
}

export default UsersResetPassword;